/**
 * =========================================================================================
 * Component - Download Apps
 * =========================================================================================
 **/

import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import UCustomScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import UDownload from "ubs-framework/v2/UDownload";
import {sendData} from '../../store/actions';
import useSocket from '../common/useSocket';

const DownloadApp = () => {
    const dispatch = useDispatch()
    const _S_ID = useSelector(e => e.common.socketId);

    const [downloadData, setDownloadData] = useState({});

    useEffect(() => {
        refresh();
        return () => off();
    }, []);

    useEffect(() => {
        sendData(dispatch, 'getBuildInfo', {});
    }, []);

    const {off, refresh} = useSocket(res => {
        if (!res.error && res?.data?.socketId === _S_ID) {
            switch (res.event) {
                case 'getBuildInfo':
                    setDownloadData(res?.data)
                    break;
                default:
                    return true;
            }
        }
    });

    return (
        <React.Fragment>
            <div className="u_layout-list">
                <div className="u_layout-scrollview">
                    <UCustomScrollBar>
                        <UDownload downloadData={downloadData}/>
                    </UCustomScrollBar>
                </div>
            </div>
        </React.Fragment>
    )
}

export default DownloadApp;
